import React from "react";

const Error = () => {
  return <h3>You are offline :( Please check your internet connection</h3>;
};

export default Error;
